import React from 'react';
import { FlexRow, formatHash, HashLength } from '@make-software/cspr-ui';
import { CopyButton } from '../copy-button/copy-button';
import { HistoryLink } from '../history-link/history-link';
import { truncateName } from '../action-messages/utils';

const CSPR_NAME_TRUNCATION_LENGTH = 24;

interface HashLinkProps {
  href: string;
  copyNotifyingStyle?: 'full' | 'tiny';
  hash: string | undefined;
  csprName?: string | null;
  hashLength?: HashLength;
}

export const HashLink = ({
  hash,
  href,
  copyNotifyingStyle,
  csprName,
  hashLength = undefined,
}: HashLinkProps) => {
  const copiedValue = csprName || hash;

  const truncatedCsprName =
    csprName && hashLength === HashLength.TINY
      ? truncateName(csprName, CSPR_NAME_TRUNCATION_LENGTH)
      : csprName;
  const formattedHash = hash ? formatHash(hash, hashLength) : null;

  return (
    <FlexRow itemsSpacing={4} align="center">
      <HistoryLink href={href}>
        {truncatedCsprName || formattedHash}
      </HistoryLink>
      <CopyButton value={copiedValue} type={copyNotifyingStyle} />
    </FlexRow>
  );
};
